import { useState, useEffect } from "react";
import styles from "../styles/contact.module.css";
import Hero from "../components/Hero";
import { useLocation } from "react-router-dom";

function Contacto() {
    const [enviado, setEnviado] = useState(false);
    const location = useLocation(); // Obtiene el objeto de ubicación
    const { planSeleccionado } = location.state || {}; // Accede al estado pasado, si existe

    const [formData, setFormData] = useState({
        nombre: "",
        telefono: "",
        email: "",
        motivo: "",
        mensaje: "",
        politica: false,
    });

    // Usa useEffect para actualizar formData cuando el componente se monta
    // o cuando planSeleccionado cambia
    useEffect(() => {
        if (planSeleccionado) {
            setFormData(prevFormData => ({
                ...prevFormData,
                motivo: `Interés en el plan ${planSeleccionado.name} ${planSeleccionado.tipo}.`,
                mensaje: `Hola, tengo interes en el plan ${planSeleccionado.name} de los planes ${planSeleccionado.tipo}. Veo que incluye ${planSeleccionado.texto1}, ${planSeleccionado.texto2}, ${planSeleccionado.texto3}, ${planSeleccionado.texto4}, ${planSeleccionado.texto5} y ${planSeleccionado.texto6}. Me gustaría recibir más información al re4specto. Gracias!`,
            }));
        }
    }, [planSeleccionado]); // Este efecto se ejecuta cuando planSeleccionado cambia

    // useEffect para enviar un evento a Google Analytics cuando la página de contacto se carga
    useEffect(() => {
        // Asegúrate de que gtag esté disponible globalmente antes de usarlo
        if (typeof window.gtag === 'function') {
            window.gtag('event', 'view_contact_page', {
                'event_category': 'Engagement',
                'event_label': 'Página de Contacto Vista',
                'page_path': location.pathname, // Puedes incluir la ruta actual
                'page_title': document.title // El título de la página
            });
        }
    }, []); // El array vacío asegura que este efecto se ejecute solo una vez al montar el componente

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const data = new FormData();
        for (const key in formData) {
            data.append(key, formData[key]);
        }

        const response = await fetch("/sendMail.php", {
            method: "POST",
            body: data,
        });

        if (response.ok) {
            setEnviado(true);
            // Opcional: También podrías enviar un evento GA aquí para el envío exitoso del formulario
            if (typeof window.gtag === 'function') {
                window.gtag('event', 'form_submission', {
                    'event_category': 'Engagement',
                    'event_label': 'Formulario de Contacto Enviado Exitosamente',
                });
            }
        } else {
            alert("Error al enviar el mensaje.");
            // Opcional: Enviar un evento GA si hay un error en el envío
            if (typeof window.gtag === 'function') {
                window.gtag('event', 'form_submission_error', {
                    'event_category': 'Engagement',
                    'event_label': 'Error al Enviar Formulario de Contacto',
                });
            }
        }
    };

    return (
        <div>
            <Hero subtitle="Pilates, Biomecánica, Nutrición, Entrenamientos, Osteopatía, Postural" />
            <section className={styles.contacto}>
                {/* ... localización, teléfono, mapa, etc ... */}

                <div className={styles.contenido}>
                    <div className={styles.mapa}>{
                        <iframe
                            title="Google Maps"
                            src="https://maps.google.com/maps?q=Terrassa&output=embed" // Usar una URL válida de Google Maps
                            width="100%"
                            height="540"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade">
                        </iframe>}</div>

                    {enviado ? (

                        <div className={styles.mensajeEnviado}>
                            <h3>
                                <span className={styles.checkIcon}>✓</span>
                                Mensaje enviado correctamente
                            </h3>
                            <p>Gracias, en breve nos pondremos en contacto contigo.</p>
                        </div>


                    ) : (


                        <form className={styles.form} onSubmit={handleSubmit}>
                            <h3>Envíanos un mensaje</h3>
                            <p className={styles.p_form}>Si lo prefieres puedes contactarnos a través del siguiente formulario.</p>

                            <input
                                type="text"
                                name="nombre"
                                placeholder="Tu nombre"
                                required
                                value={formData.nombre}
                                onChange={handleChange}
                            />
                            <div className={styles.row}>
                                <input
                                    type="text"
                                    name="telefono"
                                    placeholder="Tu teléfono"
                                    required
                                    value={formData.telefono}
                                    onChange={handleChange}
                                />
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Tu correo electrónico"
                                    required
                                    value={formData.email}
                                    onChange={handleChange}
                                />
                            </div>
                            <input
                                type="text"
                                name="motivo"
                                placeholder="Motivo de contacto"
                                value={formData.motivo}
                                onChange={handleChange}
                            />
                            <textarea
                                name="mensaje"
                                placeholder="Mensaje"
                                rows="5"
                                required
                                value={formData.mensaje}
                                onChange={handleChange}
                            ></textarea>

                            <label className={styles.politicaChecks}>
                                <input
                                    type="checkbox"
                                    name="politica"
                                    required
                                    checked={formData.politica}
                                    onChange={handleChange}
                                />
                                He leído y acepto la <a href="/privacidad">Política de Privacidad</a>
                            </label>

                            <button type="submit">ENVIAR</button>
                        </form>

                    )}
                </div>
            </section>
        </div>
    );
}

export default Contacto;
